import { http } from './http';
import type { ApiSuccess } from './types';
import type { PermissionKey } from '@auth/types';

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
  tokenType: 'Bearer';
  expiresIn: string;
  refreshExpiresIn: string;
}

export interface BootstrapPayload {
  email: string;
  password: string;
  fullName: string;
}

export interface LoginPayload {
  email: string;
  password: string;
}

export interface AccountMe {
  id: number;
  email: string;
  fullName: string;
  roleSlug: string;
  roleName: string;
  isActive: boolean;
}

export interface AccountAccess {
  roleSlug: string;
  permissions: PermissionKey[];
  canAccess: Record<string, boolean>;
}

export const authApi = {
  async bootstrapSuperAdmin(payload: BootstrapPayload): Promise<void> {
    await http.post<ApiSuccess<unknown>>('/api/auth/bootstrap-superadmin', payload);
  },

  async login(payload: LoginPayload): Promise<AuthTokens> {
    const res = await http.post<ApiSuccess<AuthTokens>>('/api/auth/login', payload);
    return res.data.data;
  },

  async refresh(refreshToken: string): Promise<AuthTokens> {
    const res = await http.post<ApiSuccess<AuthTokens>>('/api/auth/refresh', { refreshToken });
    return res.data.data;
  },

  async logout(): Promise<void> {
    await http.post('/api/auth/logout');
  },

  async me(): Promise<AccountMe> {
    const res = await http.get<ApiSuccess<AccountMe>>('/api/account/me');
    return res.data.data;
  },

  async access(): Promise<AccountAccess> {
    const res = await http.get<ApiSuccess<AccountAccess>>('/api/account/access');
    return res.data.data;
  },
};
